import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';
import type { AuditPackageDto, PackagePrecheckDto } from './types';

export const fetchPrecheck = async (batchId: string): Promise<PackagePrecheckDto> => {
  const res = await apiClient.get<ApiSuccess<PackagePrecheckDto>>(
    `/monthly-batches/${batchId}/audit-package/precheck`,
  );
  return res.data.data;
};

export const fetchPackages = async (batchId: string): Promise<AuditPackageDto[]> => {
  const res = await apiClient.get<ApiSuccess<AuditPackageDto[]>>(
    `/monthly-batches/${batchId}/audit-packages`,
  );
  return res.data.data;
};

export const generatePackage = async (batchId: string): Promise<AuditPackageDto> => {
  const res = await apiClient.post<ApiSuccess<AuditPackageDto>>(
    `/monthly-batches/${batchId}/audit-package/generate`,
  );
  return res.data.data;
};

export const downloadPackageUrl = (batchId: string, version?: number): string => {
  const base = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api';
  const qs = version != null ? `?version=${version}` : '';
  return `${base}/monthly-batches/${batchId}/audit-package/download${qs}`;
};

export const fetchManifest = async (auditPackageId: string): Promise<Record<string, unknown>> => {
  const res = await apiClient.get<ApiSuccess<Record<string, unknown>>>(
    `/audit-packages/${auditPackageId}/manifest`,
  );
  return res.data.data;
};
